export default __webpack_public_path__ + "assets/images/g-last-icon1-e398db96.svg";